import { defineMessages } from 'react-intl'

const scope = 'app.containers.Dashboard'

export default defineMessages({
  header: {
    id: `${scope}.header`,
    defaultMessage: 'Overview Dashboard',
  },
  titles: {
    totals: {
      revenue: {
        id: `${scope}.titles.totals.revenue`,
        defaultMessage: 'Total Revenue',
      },
      cases: {
        id: `${scope}.titles.totals.cases`,
        defaultMessage: 'Potential Cases',
      },
    },
    entities: {
      id: `${scope}.titles.entities`,
      defaultMessage: 'Entities',
    },
    insights: {
      id: `${scope}.titles.insights`,
      defaultMessage: 'Entities Insights',
    },
    resolvers: {
      id: `${scope}.titles.resolvers`,
      defaultMessage: 'Revenue by Resolvers',
    },
  },
})
